<template>
  <div class="login-container">
    
    <div v-if="user" class="user-info">
      Login Successful<br>
      User Name: {{ user.name }}<br>
      Email: {{ user.email }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

import { setUserState } from '../config/common';
import { useRouter } from 'vue-router'; // 如果你使用了 vue-router

const user = ref(null);
const router = useRouter();
const handleCredentialResponse = (idToken) => {
    fetch("/api/auth/google", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            token: idToken
        })
    })
    .then(r => r.json())
    .then(data => {
        
      // 简单解码 JWT 获取用户信息（实际项目中建议交给后端验证）
      const userInfo = decodeJwt(idToken);
      user.value = userInfo;

      setUserState(userInfo, data.token, 'CiAuth');
          
        const hash = window.location.hash;
        if (hash) {
          const params = new URLSearchParams(hash.substring(1));
          
          // 提取并还原你的自定义参数
          const stateStr = params.get('state');
          if (stateStr) {
            const data = JSON.parse(decodeURIComponent(stateStr));
            //console.log('[google] data', data);
            if(data.v){
              router.replace({ 
                path: data.source, 
                query: { v: data.v } 
              });
            }else{
              router.replace(data.source);
            }
          }
        }
    });
}
onMounted(() => {
  // 谷歌会在重定向回来的 URL 哈希(#)中携带 id_token
  const hash = window.location.hash;
  if (hash && hash.includes('id_token')) {
    const params = new URLSearchParams(hash.substring(1)); // 去掉 # 号
    const idToken = params.get('id_token');
    
    if (idToken) {      
      handleCredentialResponse(idToken);
    }
  }
});

// 辅助函数：解码 JWT
const decodeJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
};
</script>
<style scoped>
.login-container { text-align: center; padding: 20px; }
.user-info { margin-top: 20px; color: rgb(0, 120, 212); line-height: 1.8; }
</style>